export enum ErrorCode {
    Unknown = "Unknown",
    InvalidateSession = "InvalidateSession",
    IncompatibleAPI = "IncompatibleAPI",
    NoDevice = "NoDevice",
    NoMethod = "NoMethod",
    Unauthenticated = "Unauthenticated",
    AuthError = "AuthError",
    InvalidAPIKey = "InvalidAPIKey"
}

